import FoodAIcon from '@icons/category/FoodAIcon';
import HotCoffeeAIcon from '@icons/category/HotCoffeeAIcon';
import HotCoffeeBIcon from '@icons/category/HotCoffeeBIcon';
import HotCoffeeCIcon from '@icons/category/HotCoffeeCIcon';
import IceCoffeeAIcon from '@icons/category/IceCoffeeAIcon';
import IceCoffeeBIcon from '@icons/category/IceCoffeeBIcon';
import JuiceAIcon from '@icons/category/JuiceAIcon';
import MdAIcon from '@icons/category/MdAIcon';
import NoneCoffeeAIcon from '@icons/category/NoneCoffeeAIcon';
import TeaAdeAIcon from '@icons/category/TeaAdeAIcon';
import { IconProps } from '@models/icons';
import { JSX } from 'react';

import { CategoryKitType } from './index.d';

export const CategoryKitIcon: Record<CategoryKitType, (props: IconProps) => JSX.Element> = {
  HOT_COFFEE_A: HotCoffeeAIcon,
  HOT_COFFEE_B: HotCoffeeBIcon,
  HOT_COFFEE_C: HotCoffeeCIcon,
  ICE_COFFEE_A: IceCoffeeAIcon,
  ICE_COFFEE_B: IceCoffeeBIcon,
  NONE_COFFEE_A: NoneCoffeeAIcon,
  JUICE_A: JuiceAIcon,
  TEA_ADE_A: TeaAdeAIcon,
  FOOD_A: FoodAIcon,
  MD_A: MdAIcon,
};
